/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectDomain } from './ProjectDomain';
import {
    ProjectDomainFromJSON,
    ProjectDomainFromJSONTyped,
    ProjectDomainToJSON,
    ProjectDomainToJSONTyped,
} from './ProjectDomain';
import type { ProjectDomainStats } from './ProjectDomainStats';
import {
    ProjectDomainStatsFromJSON,
    ProjectDomainStatsFromJSONTyped,
    ProjectDomainStatsToJSON,
    ProjectDomainStatsToJSONTyped,
} from './ProjectDomainStats';
import type { ProjectCentre } from './ProjectCentre';
import {
    ProjectCentreFromJSON,
    ProjectCentreFromJSONTyped,
    ProjectCentreToJSON,
    ProjectCentreToJSONTyped,
} from './ProjectCentre';

/**
 * 
 * @export
 * @interface ProjectDomainWithStats
 */
export interface ProjectDomainWithStats {
    /**
     * 
     * @type {ProjectDomain}
     * @memberof ProjectDomainWithStats
     */
    projectDomain?: ProjectDomain;
    /**
     * 
     * @type {ProjectDomainStats}
     * @memberof ProjectDomainWithStats
     */
    projectDomainStats?: ProjectDomainStats;
    /**
     * 
     * @type {Array<ProjectCentre>}
     * @memberof ProjectDomainWithStats
     */
    centres?: Array<ProjectCentre>;
}

/**
 * Check if a given object implements the ProjectDomainWithStats interface.
 */
export function instanceOfProjectDomainWithStats(value: object): value is ProjectDomainWithStats {
    return true;
}

export function ProjectDomainWithStatsFromJSON(json: any): ProjectDomainWithStats {
    return ProjectDomainWithStatsFromJSONTyped(json, false);
}

export function ProjectDomainWithStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainWithStats {
    if (json == null) {
        return json;
    }
    return {
        
        'projectDomain': json['projectDomain'] == null ? undefined : ProjectDomainFromJSON(json['projectDomain']),
        'projectDomainStats': json['projectDomainStats'] == null ? undefined : ProjectDomainStatsFromJSON(json['projectDomainStats']),
        'centres': json['centres'] == null ? undefined : ((json['centres'] as Array<any>).map(ProjectCentreFromJSON)),
    };
}

export function ProjectDomainWithStatsToJSON(json: any): ProjectDomainWithStats {
    return ProjectDomainWithStatsToJSONTyped(json, false);
}

export function ProjectDomainWithStatsToJSONTyped(value?: ProjectDomainWithStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectDomain': ProjectDomainToJSON(value['projectDomain']),
        'projectDomainStats': ProjectDomainStatsToJSON(value['projectDomainStats']),
        'centres': value['centres'] == null ? undefined : ((value['centres'] as Array<any>).map(ProjectCentreToJSON)),
    };
}

